<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row no-gutters>
      <v-col
        class="d-inline-flex"
        cols="12"
      >
        <template v-if="!isTableOrder">
          <!-- Order Type Toggle -->
          <v-btn-toggle
            v-if="appConfig"
            v-model="posCart.OrderType"
            :disabled="disabled"
            borderless
            class="lighten-2 elevation-0 pa-0 ma-0 mr-1"
            dense
            mandatory
            style="width: 100%;"
          >
            <template v-for="item in orderTypes">
              <v-btn
                :key="item.Id"
                :class="item.Color"
                :disabled="disabled"
                :style="posCart.OrderType === item.Id ? 'opacity: 1' : 'opacity: 0.35'"
                :value="item.Id"
                class="elevation-0 white--text pa-0 flex-grow-1"
                min-width="36"
              >
                <span
                  v-if="posCart.OrderType === item.Id && $vuetify.breakpoint.mdAndUp"
                  class="mr-2"
                >
                  {{ item.Title }}
                </span>

                <v-icon
                  v-if="item.Icon"
                  color="white"
                  size="22"
                >
                  {{ item.Icon }}
                </v-icon>
              </v-btn>
            </template>
          </v-btn-toggle>

          <!-- Order Payment Toggle -->
          <payment-method-selector
            v-model="posCart.PaymentType"
            :disabled="disabled"
            :height="36"
            class="mr-1 fill-width"
          />

          <!-- Platform Type Toggle -->
          <v-btn-toggle
            v-model="platformType"
            :disabled="disabled"
            borderless
            class="lighten-2 elevation-0 ma-0"
            dense
            mandatory
            style="width: 100%;"
          >
            <v-btn
              :disabled="disabled || selectedOrderSourceType.source_type_id === 4"
              :style="platformType === 'getfoodpro' ? 'opacity: 1' : 'opacity: 0.35'"
              class="red darken-1 pa-0 elevation-0 white--text flex-grow-1"
              min-width="36"
              value="getfoodpro"
              @click="showSelectOrderSourceTypeDialog"
            >
              <span
                v-if="platformType === 'getfoodpro' && $vuetify.breakpoint.mdAndUp"
                class="mr-2"
              >
                <template v-if="parseInt(selectedOrderSourceType.source_type_id) < 100">
                  {{ getOrderSourceTypeLangById(selectedOrderSourceType.source_type_id).Title }}
                </template>
                <template v-else>
                  GETFOOD Pro
                </template>
              </span>

              <svg-logo
                v-if="selectedOrderSourceType.source_type_id > 99"
                :pro-active="false"
                class=""
                one-color="#fff"
                size="32px"
              />

              <v-avatar
                v-if="selectedOrderSourceType.source_type_id < 100"
                size="22px"
              >
                <v-icon
                  color="white"
                  size="22"
                >
                  {{ selectedOrderSourceType.logo }}
                </v-icon>
              </v-avatar>
            </v-btn>

            <v-btn
              v-if="otherSourceTypesActive"
              :disabled="disabled || (selectedOrderSourceType.source_type_id === 1 || selectedOrderSourceType.source_type_id === 4 || selectedOrderSourceType.source_type_id === 10)"
              :style="platformType === 'other' ? 'opacity: 1' : 'opacity: 0.35'"
              class="cyan elevation-0 pa-0 white--text flex-grow-1"
              min-width="36"
              value="other"
              @click="showSelectOrderSourceTypeDialog"
            >
              <span
                v-if="platformType === 'other' && $vuetify.breakpoint.mdAndUp"
                class="mr-2"
              >
                <template v-if="selectedOrderSourceType.source_type_id > 99">
                  {{ selectedOrderSourceType.title }}
                </template>
                <template v-else>
                  {{ $t('Pos.Pos.Toolbar.Source').toLocaleUpperCase($i18n.locale) }}
                </template>
              </span>

              <v-icon
                v-if="selectedOrderSourceType.source_type_id < 100"
                color="white"
                size="22"
              >
                arrow_back
              </v-icon>

              <v-avatar
                v-if="selectedOrderSourceType.source_type_id > 99"
                color="white"
                size="22px"
              >
                <v-icon
                  v-if="!selectedOrderSourceType.logo"
                  color="white"
                  size="22"
                >
                  arrow_back
                </v-icon>
                <img
                  v-if="selectedOrderSourceType.logo"
                  :src="selectedOrderSourceType.logo"
                  height="22"
                  width="auto"
                >
              </v-avatar>
            </v-btn>
          </v-btn-toggle>
        </template>

        <!-- Select Catalog -->
        <template v-if="sourceTypeHasMultipleCatalogs && !isTableOrder">
          <v-btn
            class="primary darken-1 pa-1 px-1 ml-1 elevation-0 white--text"
            style="min-width: 100px"
            @click="$bus.$emit('platform-catalog-dialog:show', posCart.SourceTypeId, true)"
          >
            <div>
              <div class="caption font-weight-bold">
                <v-icon
                  class="mb-1"
                  small
                >
                  menu_book
                </v-icon>
                {{ catalog ? catalog.Name : $t('Pos.SelectPlatformCatalogDialog.Button.ChangeCatalog') | truncate(15) }}
              </div>

              <div
                v-if="catalog"
                style="font-size: 9px;"
              >
                {{ $t('Pos.SelectPlatformCatalogDialog.Button.ChangeCatalog') }}
              </div>
            </div>
          </v-btn>
        </template>

        <!-- Cart Drawer Toggle -->
        <template v-if="$vuetify.breakpoint.xsOnly">
          <v-bottom-navigation
            color="green"
            dark
            fixed
            height="36"
            horizontal
          >
            <v-btn
              block
              color="green"
              @click="toggleCartDrawer"
            >
              <span class="text-subtitle-1 font-weight-bold white--text">{{ cartOrderTotal | currency }}</span>

              <v-icon
                color="white"
                small
              >
                add_shopping_cart
              </v-icon>
            </v-btn>
          </v-bottom-navigation>
        </template>
      </v-col>

      <template v-if="!isTableOrder || sourceTypeHasMultipleCatalogs">
        <v-col
          class="pt-1"
          cols="12"
        >
          <v-divider class="" />
        </v-col>
      </template>

      <select-order-source-type-dialog
        :platform-type.sync="platformType"
        :tmp-platform-type="tmpPlatformType"
        :visible.sync="selectOrderSourceTypeDialogVisible"
      />
    </v-row>
  </v-container>
</template>

<script>
import Auth from '@/mixins/auth'
import OrderType from '@/mixins/orders/orderType'
import SourceType from '@/mixins/orders/sourceType'
import SelectOrderSourceTypeDialog from '@/components/pos/SelectOrderSourceTypeDialog'
import SvgLogo from '@/components/common/SvgLogo'
import PosOrder from '@/mixins/pos/posOrder'
import AppData from '@/mixins/appdata'
import PosCartQueue from '@/mixins/pos/posCartQueue'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'
import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum'
import PaymentType from '@/mixins/orders/paymentType'
import PaymentMethodSelector from '@/components/payments/PaymentMethodSelector.vue'
import PosActiveCatalogs from '@/mixins/pos/posActiveCatalogs.js'

export default {
  name      : 'PosToolbar',
  components: {
    PaymentMethodSelector,
    SelectOrderSourceTypeDialog,
    SvgLogo
  },
  directives: {},
  mixins    : [Auth, AppData, PosActiveCatalogs, OrderType, PosCartQueue, PosOrder, SourceType, PaymentType],
  props     : {
    drawer: {
      type   : Boolean,
      default: false
    },
    disabled: {
      type   : Boolean,
      default: false
    },
    catalog: {
      type   : Object,
      default: undefined
    }
  },
  DataStore: {posCart: 'cart'},
  data() {
    return {
      platformType                      : 'getfoodpro',
      tmpPlatformType                   : '',
      selectOrderSourceTypeDialogVisible: false
    }
  },
  computed: {
    SourceTypeEnum() {
      return SourceTypeEnum
    },
    PaymentTypeEnum() {
      return PaymentTypeEnum
    },
    activePaymentTypes() {
      const paymentTypes = this.paymentTypesForPos
      if (this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD) return paymentTypes

      paymentTypes.push({
        name: 'MULTIPLE',
        code: PaymentTypeEnum.MULTIPLE,
        lang: {
          en: {
            Locale: 'en',
            Name  : 'Multiple Transactions'
          },
          el: {
            Locale: 'el',
            Name  : 'Πολλαπλές Συναλλαγές'
          }
        },
        icon          : 'euro_symbol',
        icon2         : 'credit_card',
        active        : true,
        color1        : 'purple darken-3',
        color2        : 'purple darken-4',
        priority      : 3,
        minOrderTotal : 0,
        orderStatus   : 11,
        orderStatusPos: 11
      })

      return paymentTypes
    },

    otherSourceTypesActive() {
      return this?.appConfig?.SOURCE_TYPES?.OTHER?.filter(item => item.active > 0 && this.isSourceTypeEnabled(item))?.length || false
    },

    sourceTypes() {
      if (this.platformType === 'getfoodpro') {
        return this.appConfig.SOURCE_TYPES.DEFAULT
      } else {
        return this.appConfig.SOURCE_TYPES.OTHER
      }
    },

    sourceTypeCount() {
      return Object.values(this.sourceTypes)?.filter(sourceType => this.isSourceTypeEnabled(sourceType))?.length || 0
    },

    showSourceTypesDialog() {
      let count = 0
      if (this.platformType === 'getfoodpro') {
        count = this.posCart.SourceTypeId < 100 ? 1 : 0
      } else {
        count = this.posCart.SourceTypeId >= 100 ? 1 : 0
      }
      return this.sourceTypeCount > count
    },

    cartOrderTotal() {
      return this.posCart?.Totals?.find(total => total.Name === 'order_total')?.AmountFormatted || 0
    },

    selectedOrderSourceType() {
      return this.getOrderSourceTypeById(this.posCart.SourceTypeId)
    },

    cartDrawer: {
      get() {
        return this.drawer
      },
      set(val) {
        this.$emit('update:drawer', val)
      }
    },

    showCartItemsBadge() {
      return this.posCart.TotalItems > 0
    }
  },

  watch: {
    'posCart.SourceTypeId': {
      immediate: true,
      handler() {
        this.platformType = this.posCart.SourceTypeId < 100 ? 'getfoodpro' : 'other'
      }
    }
  },

  created() {
  },
  beforeDestroy() {
  },

  methods: {
    toggleCartDrawer() {
      this.cartDrawer = !this.cartDrawer
    },

    showSelectOrderSourceTypeDialog() {
      if (this.posCart.SourceTypeId === SourceTypeEnum.ONLINE || this.posCart.SourceTypeId === SourceTypeEnum.MOBILE) return
      this.tmpPlatformType = this.platformType.toString()

      this.$nextTick(() => {
        if (this.showSourceTypesDialog) {
          this.selectOrderSourceTypeDialogVisible = true
        }
      })
    },

    /*isSourceTypeEnabled(item) {
      return parseInt(item.source_type_id) !== SourceTypeEnum.ONLINE && parseInt(item.source_type_id) !== SourceTypeEnum.TABLE && parseInt(item.source_type_id) !== SourceTypeEnum.MOBILE && parseInt(item.active) === 1 && (parseInt(item.source_type_id) > 99 || (this.posUserHasComponentPermission(item.name, 'ACCESS')))
    },*/

    isSourceTypeEnabled(item) {
      const allCatalogs = this.appConfig?.LOCATION_DATA?.Catalogs || []
      const sourceTypeExists = allCatalogs.some(catalog => catalog.SourceTypes.includes(parseInt(item.source_type_id)))
      const sourceTypeCanCreateOrder = allCatalogs.some(catalog => catalog.CanCreateOrder && catalog.SourceTypes.includes(parseInt(item.source_type_id)))
      const canCreateOrder = !sourceTypeExists || (sourceTypeExists && sourceTypeCanCreateOrder)

      return canCreateOrder && (parseInt(item.source_type_id) !== SourceTypeEnum.ONLINE && parseInt(item.source_type_id) !== SourceTypeEnum.TABLE && parseInt(item.source_type_id) !== SourceTypeEnum.MOBILE && parseInt(item.active) === 1 && (parseInt(item.source_type_id) > 99 || (this.posUserHasComponentPermission(item.name, 'ACCESS'))))
    }
  }
}
</script>

<style scoped>

</style>
